import { memo } from 'react';
import ClipBackgroundSelector from '../../SideBar/ClipBackgroundSelector/ClipBackgroundSelector';

function ClipCustomizerBackgroundPopup() {
  return (
    <div className="flex max-h-[54vh] w-[23rem] flex-col rounded-lg border bg-white shadow">
      <div className="sticky top-0 z-10 flex items-center justify-between bg-white px-4 py-3">
        <div className="text-lg font-medium">Background</div>
      </div>
      <div className="relative min-h-40">
        <div className="w-[23rem] px-4 py-3">
          <ClipBackgroundSelector hideTitle={true} />
        </div>
      </div>
    </div>
  );
}

export default memo(ClipCustomizerBackgroundPopup);
